import { render, staticRenderFns } from "./pipeline_vulnerability_report.vue?vue&type=template&id=b06c7f46&"
import script from "./pipeline_vulnerability_report.vue?vue&type=script&lang=js&"
export * from "./pipeline_vulnerability_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports